import React, { useEffect, useState } from "react";

import { CommonHeader } from "../../../components/commons";
import JobsToBeEstimateListing from "./JobsToBeEstimateListing";
import EstimateApprovedList from "./EstimateApprovedList";
import ApprovedCalander from "../../../components/Scheduling/viewPages/ApprovedCalander";
import ApprovalPendingList from "./ApprovalPendingList";
import { useLocation } from "react-router-dom";
type TabsType = {
  name: string;
  label: string;
};
const tabs: TabsType[] = [
  {
    name: "Jobs to be Estimate",
    label: "jobsToBeEstimate",
  },
  {
    name: "Approval Pending",
    label: "approvalPending",
  },
  {
    name: "Approved Estimate",
    label: "estimateApproved",
  },
  {
    name: "Employee Schedule",
    label: "employeeSchedule",
  },
];
type AppProps = {
  history?: any;
};
const UserView = ({ history }: AppProps) => {
  const [activeTab, setActiveTab] = useState(tabs[0].label);

  let isRedirected: string | null = localStorage.getItem("isRedirected");
  const search = useLocation().search;
  const notificationRedirectActiveTab = new URLSearchParams(search).get(
    "activeTab"
  );
  const notificationRedirectRequestId = new URLSearchParams(search).get(
    "request_id"
  );
  const notificationRedirectClientCode = new URLSearchParams(search).get(
    "client_code"
  );
  const notificationRedirectClientName = new URLSearchParams(search).get(
    "name"
  );
  const notificationRedirectJobType = new URLSearchParams(search).get(
    "job_type"
  );
  const notificationRedirectId = new URLSearchParams(search).get(
    "notification_id"
  );
  const redirectActiveTab = history?.location?.state;

  useEffect(() => {
    if (
      notificationRedirectActiveTab === "estimateApproved" ||
      redirectActiveTab === "estimateApproved"
    ) {
      setActiveTab("estimateApproved");
    } else if (redirectActiveTab?.userId) {
      setActiveTab("employeeSchedule");
    }
  }, [
    notificationRedirectActiveTab,
    notificationRedirectRequestId,
    redirectActiveTab,
  ]);
  useEffect(() => {
    if (isRedirected == "employeeSchedule") {
      setActiveTab("employeeSchedule");
    }
  }, [isRedirected]);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };
  const renderTabs = () => {
    const finalTab = tabs?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className="pointer mr-2"
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 5px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "14px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTab;
  };

  const activeTabRender = () => {
    switch (activeTab) {
      case "jobsToBeEstimate":
        return (
          <JobsToBeEstimateListing
            activeTab={activeTab}
            history={history}
            notificationRedirectClientCode={notificationRedirectClientCode}
            notificationRedirectRequestId={notificationRedirectRequestId}
            notificationRedirectClientName={notificationRedirectClientName}
            notificationRedirectJobType={notificationRedirectJobType}
            notificationRedirectId={notificationRedirectId}
            notificationRedirectActiveTab={notificationRedirectActiveTab}
          />
        );
      case "approvalPending":
        return <ApprovalPendingList />;
      case "estimateApproved":
        return (
          <EstimateApprovedList
            activeTab={activeTab}
            history={history}
            requestId={notificationRedirectRequestId}
            notificationRedirectId={notificationRedirectId}
          />
        );
      case "employeeSchedule":
        return (
          <ApprovedCalander
            isEdit={true}
            isRedirected={isRedirected}
            redirectData={redirectActiveTab}
          />
        );
      default:
        return (
          <JobsToBeEstimateListing
            activeTab={activeTab}
            history={history}
            notificationRedirectClientCode={notificationRedirectClientCode}
            notificationRedirectRequestId={notificationRedirectRequestId}
            notificationRedirectClientName={notificationRedirectClientName}
            notificationRedirectJobType={notificationRedirectJobType}
            notificationRedirectId={notificationRedirectId}
            notificationRedirectActiveTab={notificationRedirectActiveTab}
          />
        );
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="Estimate Jobs" />
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px",
          }}
        >
          <div className="d-flex">{renderTabs()}</div>
        </div>
      </div>

      <div className="col-md-12">
        <div style={{ border: "1px solid #bfcbe1", backgroundColor: "#fff" }}>
          {activeTabRender()}
        </div>
      </div>
    </>
  );
};

export default UserView;
